module.exports = __webpack_public_path__ + "static/media/lorelai-2.26e5348f.wav";